const REPORTED_SYMBOL = Symbol.for("@bestowinc/tinkertoy-client:failure-reported");

/** Marks a failure object so the shell boundary does not report it again. */
export function markFailureReported(target: object): void {
  Object.defineProperty(target, REPORTED_SYMBOL, {
    value: true,
    enumerable: false,
    configurable: true,
  });
}

/** Returns true when this failure was already reported at its origin site. */
export function wasFailureReported(target: unknown): boolean {
  if (typeof target !== "object" || target === null) {
    return false;
  }
  return Reflect.get(target, REPORTED_SYMBOL) === true;
}
